<template>
  <div class="timeless-regulations-container">
    <div class="timeless-regulations-content">
      <h1>iTender Անժամկետ տենդերների կանոնակարգ</h1>
      
      <h2>1. Ընդհանուր դրույթներ</h2>
      
      <p>1.1. Սույն կանոնակարգը կարգավորում է iTender էլեկտրոնային հարթակում գործող Անժամկետ տենդերների շրջանակում գնման, վաճառքի և գործարքների իրականացման կարգը։</p>
      
      <p>1.2. Անժամկետ տենդերները նախատեսված են՝</p>
      <ul>
        <li>գնորդների համար՝ մշտապես հասանելի, թարմացված և մրցակցային գներով գնումներ իրականացնելու,</li>
        <li>մասնակիցների (վաճառողների) համար՝ իրենց ապրանքները ներկայացնելու և մրցակցային միջավայրում վաճառելու նպատակով։</li>
      </ul>
      
      <p>1.3. Անժամկետ տենդերների տրամաբանությունը հիմնված է շարունակական մրցակցության, թափանցիկ դասակարգման և անմիջական, արագ գործարքների սկզբունքի վրա։</p>
      
      <h2>2. Անժամկետ տենդերների ձևավորումը</h2>
      
      <p>2.1. Անժամկետ տենդերները ձևավորվում են iTender համակարգում՝ համակարգի օպերատորի կողմից սահմանված ընդհանուր կառուցվածքով։</p>
      
      <p>2.2. Անժամկետ տենդերների շրջանակում կիրառվում են մրցակցային տեխնիկական բնութագրեր, ստանդարտացված գնման և վճարման ժամանակացույցեր, մատակարարման պայմաններ, որոնք չեն ենթակա փոփոխման գնորդների կամ մասնակիցների կողմից։</p>
      
      <p>2.3. Անժամկետ տենդերներում նախապես սահմանված քանակական ցուցանիշներ չկան։<br>Քանակները ներկայացվում են մասնակիցների կողմից։</p>
      
      <h2>3. Ապրանքների ավելացումը</h2>
      
      <p>3.1. Անժամկետ տենդերների շրջանակում ապրանքներ կարող են ավելացնել՝</p>
      <ul>
        <li>iTender համակարգի օպերատորը,</li>
        <li>գնորդները՝ իրենց մշտական կամ պարբերական կարիքները ներկայացնելու նպատակով,</li>
        <li>մասնակիցները (վաճառողները)՝ մրցակցային առաջարկներ ներկայացնելու նպատակով։</li>
      </ul>
      
      <p>3.2. Ապրանքներ ավելացնելիս կողմերը պարտավոր են առաջնորդվել մրցակցային տրամաբանությամբ՝ հնարավորինս խուսափելով չափազանց կոնկրետ ապրանքանիշերի, մոդելների կամ սահմանափակող ձևակերպումների օգտագործումից, որպեսզի ապահովվի բաց և արդյունավետ մրցակցություն։</p>
      
      <h2>4. Մասնակիցների առաջարկները</h2>
      
      <p>4.1. Մասնակիցները ներկայացնում են՝</p>
      <ul>
        <li>մատակարարման ենթակա քանակները,</li>
        <li>համապատասխան գնային առաջարկները։</li>
      </ul>
      
      <p>4.2. Մասնակիցները կարող են սահմանել՝</p>
      <ul>
        <li>նվազագույն պատվերի քանակ,</li>
        <li>քանակային շեմեր,</li>
        <li>և յուրաքանչյուր շեմի համար համապատասխան գին։</li>
      </ul>
      
      <p>4.3. Մասնակիցը կարող է ցանկացած պահի փոփոխել իր ներկայացրած քանակները և գները, բացառությամբ այն դեպքերի, երբ արդեն ստացել և հաստատել է պատվեր։</p>
      
      <h2>5. Գների դասակարգումը և տեսանելիությունը</h2>
      
      <p>5.1. Գնորդներին համակարգում տեսանելի են տվյալ պահին լավագույն հինգ տեղերը զբաղեցրած մասնակիցների առաջարկները։</p>
      
      <p>5.2. Մասնակիցների նույնականացնող տվյալները (անվանում, կոնտակտային տվյալներ և այլն) մինչև պատվերի հաստատումը հասանելի չեն։</p>
      
      <p>5.3. Մասնակիցների տվյալները բացվում են միայն այն դեպքում, երբ մասնակիցը հաստատում է պատվերը։</p>
      
      <h2>6. Գների համեմատությունը</h2>
      
      <p>6.1. Կախված նրանից, թե գնորդը հանդիսանում է ԱԱՀ վճարող, թե ոչ, գների համեմատությունը իրականացվում է՝</p>
      <ul>
        <li>առանց ԱԱՀ կամ</li>
        <li>հատուցման գներով։</li>
      </ul>
      
      <p>6.2. Եթե գնորդը ԱԱՀ վճարող է, ապա համակարգում գները դասակարգվում են առանց ԱԱՀ, իսկ վճարումը կատարվում է ներառյալ ԱԱՀ։</p>
      
      <h2>7. Պատվերի ձևավորումը և հաստատումը</h2>
      
      <p>7.1. Գնորդը կարող է անմիջապես համակարգի միջոցով գնում կատարել լավագույն հինգ տեղերը զբաղեցրած մասնակիցներից՝ նշելով ձեռք բերվող քանակը։</p>
      
      <p>7.2. Գնորդը չի կարող մասնակցից ձեռք բերել ավելի մեծ քանակ, քան տվյալ պահին մասնակցի կողմից ներկայացված և համակարգում հասանելի քանակը։</p>
      
      <p>7.3. Պատվերը համակարգի միջոցով ուղարկվում է մասնակցին՝ հաստատման կամ մերժման համար։</p>
      
      <p>7.4. Մասնակիցը պարտավոր է պատվերը ստանալուց հետո մինչև 1 (մեկ) աշխատանքային օրվա ընթացքում հաստատել կամ մերժել այն։</p>
      
      <p>7.5. Նշված ժամկետում պատվերը չհաստատելու դեպքում այն համարվում է մերժված։</p>
      
      <h2>8. Պատվերի մերժման հետևանքները</h2>
      
      <p>8.1. Եթե մասնակիցը, անկախ պատճառից, այդ թվում՝ էլեկտրոնային ստորագրության բացակայության պատճառով, մեկից ավելի անգամ մերժում է պատվերը, համակարգը կարող է՝</p>
      <ul>
        <li>ավտոմատ հեռացնել տվյալ մասնակցի բոլոր գնային առաջարկները,</li>
        <li>դադարեցնել տվյալ մասնակցի հասանելիությունը Անժամկետ տենդերների հարթակին։</li>
      </ul>
      
      <h2>9. Պայմանագրի կնքումը</h2>
      
      <p>9.1. Գործարքի արդյունքում կողմերի միջև կնքվում է պայմանագիր, որը հաստատվում է iTender համակարգում էլեկտրոնային թվային ստորագրությամբ՝ ՀՀ օրենսդրությամբ թույլատրելի ստորագրության միջոցներով (ներառյալ՝ mID, ID Card)։</p>
      
      <p>9.2. Պայմանագրի կնքման քայլերի հաջորդականությունը ներկայացված է համակարգում։</p>
      
      <h2>10. Վճարումը և մատակարարումը</h2>
      
      <p>10.1. Վաճառողը պարտավոր է ապրանքների մատակարարումն իրականացնել գնման ժամանակացույցով սահմանված ժամկետներում, մատակարարման պայմաններին համապատասխան և հաստատված քանակներով։</p>
      
      <p>10.2. Գնորդը պարտավոր է վճարումը կատարել վճարման ժամանակացույցով սահմանված ժամկետներում և պայմաններով։</p>
      
      <p>10.3. Կողմերից որևէ մեկի պարտավորությունների չկատարումը դիտարկվում է որպես պայմանների խախտում և կարող է առաջացնել տվյալ օգտատիրոջ հասանելիության դադարեցում Անժամկետ տենդերների հարթակին։</p>
      
      <h2>11. Տվյալների հասանելիությունը և օգտագործումը</h2>
      
      <p>11.1. Պատվերի հաստատումից հետո տվյալները հասանելի են դառնում գործարքի կողմերին։</p>
      
      <p>11.2. Գործարքից հետո տվյալները կարող են օգտագործվել iTender-ի կողմից վերլուծական, վիճակագրական և համակարգի կատարելագործման նպատակներով։</p>
      
      <h2>12. Եզրափակիչ դրույթներ</h2>
      
      <p>12.1. iTender համակարգի միջոցով ուղարկված բոլոր ծանուցումները համարվում են ստացված օգտատիրոջ անձնական հաշվում հասանելի դառնալու պահից։</p>
      
      <p>12.2. Սույն կանոնակարգով սահմանված ժամկետների պահպանումը կարող է ժամանակավորապես կասեցվել անհաղթահարելի ուժի (force majeure) ազդեցության դեպքում։ Անհաղթահարելի ուժի հանգամանքներ են համարվում բնական աղետները, պատերազմը կամ ռազմական գործողությունները, ռազմական կամ արտակարգ դրության հայտարարումը, քաղաքական հուզումները, գործադուլները, հաղորդակցության կամ տեղեկատվական համակարգերի խափանումները, պետական մարմինների ակտերը կամ այլ իրադարձություններ, որոնք օբյեկտիվորեն անհնարին են դարձնում պարտավորությունների կատարումը։ Նման դեպքերում կողմերը ազատվում են պատասխանատվությունից, իսկ ժամկետների հաշվարկը կասեցվում է մինչև այդ հանգամանքների վերացումը։</p>
      
      <p>12.3. Գրանցվելով iTender համակարգում, օգտվելով Անժամկետ տենդերների հարթակից, կատարելով գնումներ կամ ներկայացնելով առաջարկներ՝ օգտատերը հաստատում է, որ ծանոթացել է սույն կանոնակարգին, լիովին հասկացել է դրա բովանդակությունը և ընդունում է այն առանց վերապահումների։</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TimelessTenderRegulations',
  mounted() {
    console.log('Timeless Tender Regulations component mounted');
  }
}
</script>

<style scoped>
.timeless-regulations-container {
  max-width: 900px;
  margin: 0 auto;
  padding: 20px;
  font-family: Arial, sans-serif;
  line-height: 1.6;
  color: #333;
}

.timeless-regulations-content {
  background: #fff;
  padding: 40px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

h1 {
  text-align: center;
  color: #2c3e50;
  font-size: 28px;
  font-weight: bold;
  margin-bottom: 30px;
  padding-bottom: 15px;
  border-bottom: 3px solid #3498db;
}

h2 {
  color: #2c3e50;
  font-size: 20px;
  font-weight: bold;
  margin-top: 30px;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 2px solid #e0e0e0;
}

p {
  margin-bottom: 15px;
  font-size: 14px;
  text-align: justify;
}

strong {
  font-weight: bold;
  color: #2c3e50;
}

ul {
  margin: 15px 0;
  padding-left: 30px;
}

ul li {
  margin-bottom: 8px;
  font-size: 14px;
  line-height: 1.6;
}

/* Responsive design */
@media (max-width: 768px) {
  .timeless-regulations-content {
    padding: 20px;
  }
  
  h1 {
    font-size: 24px;
  }
  
  h2 {
    font-size: 18px;
  }
  
  p, ul li {
    font-size: 13px;
  }
}

/* Print styles */
@media print {
  .timeless-regulations-container {
    max-width: 100%;
    padding: 0;
  }
  
  .timeless-regulations-content {
    box-shadow: none;
    padding: 20px;
  }
}
</style>
